(function () {
  if (window.__rzHome) return; window.__rzHome = true;
  var d = document;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var designMode = window.Shopify && window.Shopify.designMode;

  /* ---------- reveal on scroll ---------- */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -6% 0px' }) : null;
  function reveal() {
    d.querySelectorAll('.rz-reveal:not(.is-in)').forEach(function (el) { if (!io || designMode) el.classList.add('is-in'); else io.observe(el); });
  }
  window.rzReveal = reveal;

  /* ---------- panels (menu, search, cart, filters, size guide) ---------- */
  var lastFocus;
  function openPanel(name) {
    var p = d.querySelector('[data-rz-panel="' + name + '"]'); if (!p) return false;
    closeAll(true);
    lastFocus = d.activeElement;
    p.classList.add('is-open'); p.setAttribute('aria-hidden', 'false');
    if (name === 'cart' && !openPanel._cartFresh) { openPanel._cartFresh = true; refreshCart(false); }
    d.documentElement.classList.add('rz-lock');
    var f = p.querySelector('input[type=search], .rz-close'); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 80);
    return true;
  }
  function closeAll(silent) {
    d.querySelectorAll('[data-rz-panel].is-open').forEach(function (p) { p.classList.remove('is-open'); p.setAttribute('aria-hidden', 'true'); });
    d.documentElement.classList.remove('rz-lock');
    if (!silent && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  window.rzOpen = openPanel;

  /* ---------- toast ---------- */
  var toast;
  function showToast(html) {
    if (!toast) { toast = d.createElement('div'); toast.className = 'rz-toast'; toast.setAttribute('role', 'status'); d.body.appendChild(toast); }
    toast.innerHTML = html; toast.classList.add('is-visible');
    clearTimeout(toast._t); toast._t = setTimeout(function () { toast.classList.remove('is-visible'); }, 3500);
  }

  /* ---------- cart ---------- */
  function setCount(n) { d.querySelectorAll('[data-rz-cart-count], #CartCount').forEach(function (el) { el.textContent = n; el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }); }
  function refreshCart(open) {
    return fetch(ROOT + '?sections=rz-cart-drawer').then(function (r) { return r.json(); }).then(function (data) {
      var tmp = d.createElement('div'); tmp.innerHTML = data['rz-cart-drawer'];
      var fresh = tmp.querySelector('[data-rz-cart-body]'); var cur = d.querySelector('[data-rz-cart-body]');
      if (fresh && cur) { cur.replaceWith(fresh); setCount(fresh.getAttribute('data-count')); openPanel._cartFresh = true; }
      if (open) openPanel('cart');
    });
  }
  function addToCart(body, btn) {
    if (btn) btn.classList.add('is-loading');
    return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: body })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (item) {
        try { d.dispatchEvent(new CustomEvent('rz:added', { detail: item })); } catch (e) {}
        if (d.body.classList.contains('template-cart')) { location.reload(); return; }
        return refreshCart(true);
      })
      .catch(function (err) { showToast('<span>' + ((err && (err.description || err.message)) || 'Could not add to bag') + '</span>'); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  }
  function changeLine(line, qty, el) {
    var item = el && el.closest('.rz-cart__item'); if (item) item.classList.add('is-loading');
    return fetch(ROOT + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: +line, quantity: +qty }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return refreshCart(false); })
      .catch(function (err) { if (item) item.classList.remove('is-loading'); showToast('<span>' + ((err && (err.description || err.message)) || 'Could not update bag') + '</span>'); });
  }

  /* ---------- load more ---------- */
  function loadMore(a) {
    a.classList.add('is-loading');
    fetch(a.href).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var grid = d.querySelector('[data-rz-grid]') || d.querySelector('.rz-grid--coll');
      var newGrid = doc.querySelector('[data-rz-grid]') || doc.querySelector('.rz-grid--coll');
      if (grid && newGrid) Array.prototype.slice.call(newGrid.children).forEach(function (c) { grid.appendChild(c); });
      var wrap = a.closest('.rz-more'), newWrap = doc.querySelector('.rz-more');
      if (wrap) { if (newWrap) wrap.replaceWith(newWrap); else wrap.remove(); }
      if (history.replaceState) history.replaceState(null, '', a.href);
      reveal();
    }).catch(function () { location.href = a.href; });
  }

  /* ---------- colour dots on product cards (each colour is its own product) ---------- */
  function swapCard(sw) {
    var card = sw.closest('.rz-card'); if (!card) return;
    var url = sw.getAttribute('data-rz-sw');
    card.querySelectorAll('[data-rz-sw]').forEach(function (b) { var on = b === sw; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    var img = card.querySelector('.rz-card__media img');
    if (img && sw.getAttribute('data-img')) { img.removeAttribute('srcset'); img.src = sw.getAttribute('data-img'); img.srcset = sw.getAttribute('data-srcset'); }
    card.classList.add('is-swapped');
    card.querySelectorAll('a.rz-card__media, a.rz-card__info').forEach(function (a) { a.href = url; });
    var order = getComputedStyle(card).order;
    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'sections=rz-card-render').then(function (r) { return r.json(); }).then(function (j) {
      var t = d.createElement('div'); t.innerHTML = j['rz-card-render'] || '';
      var fresh = t.querySelector('.rz-card'); if (!fresh || !card.isConnected) return;
      fresh.classList.remove('rz-reveal'); fresh.classList.add('is-in', 'is-swapped'); fresh.style.transitionDelay = '0ms'; fresh.style.order = order;
      var fi = fresh.querySelector('.rz-card__media img'); if (fi && img) { fi.loading = 'eager'; }
      card.replaceWith(fresh);
    }).catch(function () {});
  }

  /* ---------- instant-feeling navigation: fetch a product page as soon as a finger lands on its link ---------- */
  var prefetched = {};
  function prefetch(a) {
    var href = a && a.getAttribute('href'); if (!href || prefetched[href] || !/\/(products|collections)\//.test(href) || a.target === '_blank') return;
    prefetched[href] = 1; var l = d.createElement('link'); l.rel = 'prefetch'; l.href = href; l.as = 'document'; d.head.appendChild(l);
  }
  d.addEventListener('touchstart', function (e) { prefetch(e.target.closest && e.target.closest('a[href]')); }, { passive: true });
  d.addEventListener('mouseover', function (e) { var a = e.target.closest && e.target.closest('a[href]'); if (a) { clearTimeout(a._pf); a._pf = setTimeout(function () { prefetch(a); }, 65); } }, { passive: true });

  /* ---------- global events ---------- */
  d.addEventListener('click', function (e) {
    var o = e.target.closest('[data-rz-open]');
    if (o) { if (openPanel(o.getAttribute('data-rz-open'))) e.preventDefault(); return; }
    if (e.target.closest('[data-rz-close]') || e.target.matches('[data-rz-panel]')) { closeAll(); return; }
    var sw = e.target.closest('[data-rz-sw]');
    if (sw) { e.preventDefault(); swapCard(sw); return; }
    var add = e.target.closest('[data-rz-add]');
    if (add && !add.disabled) { e.preventDefault(); var fd = new FormData(); fd.append('id', add.getAttribute('data-rz-add')); fd.append('quantity', 1); addToCart(fd, add); return; }
    var line = e.target.closest('[data-rz-line]');
    if (line) { e.preventDefault(); changeLine(line.getAttribute('data-rz-line'), line.getAttribute('data-qty'), line); return; }
    var more = e.target.closest('[data-rz-more]');
    if (more) { e.preventDefault(); loadMore(more); return; }
    var dot = e.target.closest('.rzh-spot__dot');
    d.querySelectorAll('.rzh-spot.is-open').forEach(function (s) { if (!dot || s !== dot.parentNode) { s.classList.remove('is-open'); s.querySelector('.rzh-spot__dot').setAttribute('aria-expanded', 'false'); } });
    if (dot) { var s = dot.parentNode; dot.setAttribute('aria-expanded', s.classList.toggle('is-open')); }
  });
  d.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-rz-product-form]'); if (!f) return;
    e.preventDefault();
    addToCart(new FormData(f), f.querySelector('[type=submit]'));
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- header behaviour ---------- */
  function initHeader() {
    var header = d.querySelector('[data-rz-header]'); if (!header) return;
    var heroTop = d.querySelector('[data-rzh-top]');
    if (header.classList.contains('rz-header--home') && heroTop && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { header.classList.toggle('is-visible', !en[0].isIntersecting); }).observe(heroTop);
    } else {
      header.classList.add('is-visible');
      var lastY = scrollY;
      addEventListener('scroll', function () {
        var y = scrollY;
        header.classList.toggle('is-scrolled', y > 10);
        header.classList.toggle('is-hidden', y > lastY && y > 240 && !d.documentElement.classList.contains('rz-lock'));
        lastY = y;
      }, { passive: true });
    }
  }

  function init() { reveal(); initHeader(); }
  if (d.readyState !== 'loading') init(); else d.addEventListener('DOMContentLoaded', init);
  d.addEventListener('shopify:section:load', reveal);
})();
